module.exports = __webpack_public_path__ + "img/item_2.5f45a257.png";